import { Box, IconButton, Tooltip, Typography, useTheme, } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'
import React, { useEffect } from 'react'
import { toast } from 'react-toastify'
import { useState } from 'react'

import DataLoadingSpinner from '../../../components/common/DataLoadingSpinner'
import CustomTable from '../../../components/common/custom-table/CustomTable'
import BreadcrumbList from '../../../components/common/BreadcrumbList'
import noParticipationsImg from '../../../assets/no-data.svg'
import { formatDate, Icons } from '../../../utils/utilities'
import api from '../../../service/api'
import { useExamStore } from '../../../store/exam.store'

const columns = [
    { field: "exam_title", name: "Exam Name", borderRadius: "5px 0 0 0", width: "220px", align: "left", rowPadding: "10px 20px" },
    { field: "exam_participation_attempt", name: "Attempt", width: "20px", align: "center" },
    { field: "exam_participation_start_time", renderCell: row => formatDate( row.exam_participation_start_time, { format: "DD-MM-YYYY hh:mm A" } ), name: "Exam date", maxWidth: "50px", width: '200px', align: "left" },
    { field: "exam_participation_score", name: "Score", width: '130px', align: "center" },
    { field: "exam_participation_remark", renderCell: row => row.exam_participation_remark || "No remarks.", name: "Remark", width: '130px', align: "left", rowPadding: "10px 20px" }
]
export default function Scores () {
    const [data, setData] = useState( [] )
    const [participations, setParticipations] = useState( [] )
    const [inProgress, setInProgress] = useState( true )
    const [isScoreHidden, setIsScoreHidden] = useState( false )

    const { exam_id } = useParams()

    const { border, palette, layout } = useTheme()
    const navigate = useNavigate()

    const ExamStore = useExamStore()

    useEffect( () => {

        const getData = async () => {
            try {
                await ExamStore.fetchExam( exam_id )
                if ( !ExamStore.getExam?.exam?.exam_constraints?.hide_scores ) {

                    const { data } = await api.fetchUserParticipations()
                    setData( data.participation )
                    setParticipations( data.participation )
                    if ( exam_id ) {
                        const filteredParticipations = ( data.participation || [] )?.filter( p => +p.exam_id === +exam_id )
                        setParticipations( filteredParticipations )
                    }
                } else {
                    setIsScoreHidden( true )
                }
            }
            catch ( e ) {
                toast( e?.response?.data?.message || "Something went wrong!" )
            }
            finally {
                setInProgress( false )
            }
        }
        getData()
    }, [exam_id, ExamStore] )

    return (
        <Box padding={layout.pagePadding} flexGrow={1} overflow={inProgress || ( !inProgress && data?.length === 0 ) ? "initial" : "auto"} display="flex" flexDirection="column">
            <BreadcrumbList items={[
                { link: "/student/exams", label: "Exams" },
                "Scores",
                { link: "/student/exams", label: data?.[0]?.exam_title || exam_id },
            ]} />
            <Box gap={layout.sectionsGap} sx={{ minHeight: "500px", display: "flex", flexDirection: "column", flexGrow: inProgress || ( !inProgress && data?.length === 0 ) ? "initial" : 1, overflow: inProgress || ( !inProgress && data?.length === 0 ) ? "initial" : "auto" }}>
                <Box display="flex" gap={layout.cardsGap} alignItems="center" >
                    <Tooltip title="Back to exam">
                        <IconButton color='primary' sx={{ border: `2px solid ${palette.primary.main}` }} size='small' onClick={() => navigate( `/student/exams/${exam_id}` )}>
                            {Icons.default.ArrowBack}
                        </IconButton>
                    </Tooltip>
                    <Box >
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">My {ExamStore.getExam?.exam?.exam_name} scores</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Check your scores</Typography>
                    </Box>
                </Box>
                {!inProgress && participations && participations?.length > 0 && !isScoreHidden && <Box borderRadius="5px" flexGrow={1} overflow="auto">
                    <CustomTable pageSize={20} onRowClick={( row ) => navigate( `/student/scores/${row.exam_id}/${row.participation_id}` )} columns={columns} data={participations} />
                </Box>}
                {!isScoreHidden && ( !participations || participations.length === 0 ) && !inProgress && <Box bgcolor={palette.contentBg} borderRadius={layout.borderRadius} display="flex" flexDirection="column" gap="10px" alignItems="center" justifyContent="center" padding="20px">
                    <Box component="img" src={noParticipationsImg} width="200px" alt="No participations" />
                    <Typography variant='subtitle2' textAlign="center" >You seems to have not participated in the exam <em>{data?.[0]?.exam_title}</em>!</Typography>
                </Box>}
                {isScoreHidden && !inProgress && <Box bgcolor={palette.contentBg} borderRadius={layout.borderRadius} display="flex" flexDirection="column" gap="10px" alignItems="center" justifyContent="center" padding="20px">
                    <Box component="img" src={noParticipationsImg} width="200px" alt="Hidden Scores" />
                    <Typography variant='subtitle2' textAlign="center" >Scores of this exam are hidden! please contact exam conductor for more information.</Typography>
                </Box>}
                {inProgress && <DataLoadingSpinner padding="0" waitingMessage="Loading your scores..." />}
            </Box >
        </Box >
    )
}
